import React from 'react';
import PropTypes from 'prop-types';

import GeneralControllers from './GeneralControllers';
import StyleControllers from './StyleControllers';
import LabelControllers from './LabelControllers';
import GridControllers from './GridControllers';
import LegendControllers from './LegendControllers';
import InteractivityController from './InteractivityController';

const Controllers = ({
  handle,
  config,
  data,
  extend,
  setExtend,
  selectedColumn,
}) => (
  <>
    {[
      GeneralControllers,
      StyleControllers,
      LabelControllers,
      GridControllers,
      LegendControllers,
      InteractivityController,
    ].map((Group) => (
      <Group
        key={Group.name}
        handle={handle}
        config={config}
        data={data}
        extend={extend}
        setExtend={setExtend}
        selectedColumn={selectedColumn}
      />
    ))}
  </>
);

Controllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  selectedColumn: PropTypes.objectOf(PropTypes.any),
};

Controllers.defaultProps = {
  config: undefined,
  data: undefined,
  handle: () => {},
  extend: '',
  setExtend: () => {},
  selectedColumn: undefined,
};

export default Controllers;
